import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxIntuitiveTeethDiagramFacade } from '../../rx-intuitive-teeth-diagram.facade';
import { combineLatest, takeUntil } from 'rxjs';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { TlkCardComponent } from '@itero/ui-toolkit-angular/card';

/**
 * Presentational shell: diagram column + indication controls, separator, side panel.
 * Parent supplies optional `rx-intuitive-teeth-diagram-toolbar`, then `rx-intuitive-teeth-diagram-diagram`,
 * `rx-intuitive-teeth-diagram-buttons`, and `rx-intuitive-teeth-diagram-panel`.
 */
@Component({
	selector: 'rx-intuitive-teeth-diagram-layout',
	templateUrl: './rx-intuitive-teeth-diagram-layout.component.html',
	styleUrls: ['./rx-intuitive-teeth-diagram-layout.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TlkCardComponent, CommonModule]
})
export class RxIntuitiveTeethDiagramLayoutComponent extends BaseDestroyableComponent implements OnInit {
	readonly upperJaw$ = this.facade.upperJaw$;
	readonly lowerJaw$ = this.facade.lowerJaw$;
	readonly injectedSpritesContent$ = this.facade.injectedSpritesContent$;

	constructor(private readonly facade: RxIntuitiveTeethDiagramFacade) {
		super();
	}
	ngOnInit(): void {
		combineLatest([this.upperJaw$, this.lowerJaw$])
			.pipe(takeUntil(this.componentAlive$))
			.subscribe(([upper, lower]) => this.facade.syncInjectedSpritesContent(upper, lower));
	}

	trackByMapKey(index: number, item: { key: string }): string {
		return item.key;
	}
}
